import styled from '@mui/styled-engine'
import { alpha, Box, ButtonBase } from '@mui/material'

export const DayContainer = styled(Box)(({
  theme,
  inselection,
  last,
  first,
  isendofweek,
  isstartofweek
}) => {
  const styles = {
    width: 40,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
  if (inselection) {
    const radiusLeft = first || isstartofweek ? 16 : 0
    const radiusRight = last || isendofweek ? 16 : 0

    return {
      ...styles,
      borderRadius: `${radiusLeft}px ${radiusRight}px ${radiusRight}px ${radiusLeft}px`,
      backgroundColor: theme.palette.surface.secondary,
      borderLeft: first ? '1px solid' : 'none',
      borderRight: last ? '1px solid' : 'none',
      borderColor: theme.palette.border.primary
    }
  }

  return {
    ...styles,
  }
})


export const DayButton = styled(ButtonBase)(({
  theme,
  inselection,
  outofmonth,
  selected,
  disabled,
}) => {
  const styles = {
    width: selected ? '100%' : 32,
    height: 24,
    borderRadius: selected ? 16 : 4,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: 12,
    color: theme.palette.text.body.primary,
    lineHeight: 1.5,
  }
  if (disabled) {
    return {
      ...styles,
      opacity: 0.4,
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        opacity: 0.5
      }
    }
  }
  if (selected) {
    return {
      ...styles,
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    }
  }
  if (inselection) {
    return {
      ...styles,
      backgroundColor: theme.palette.surface.secondary,
      '&:hover': {
        backgroundColor: theme.palette.surface.secondary,
      },
    }
  }
  if (outofmonth) {
    return {
      ...styles,
      opacity: 0.4,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      },
    }
  }
  return {
    ...styles,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  }
})